module.exports = __webpack_public_path__ + "static/media/Screenshot_6-thumb.27d648e2.png";